import { render, staticRenderFns } from "./CartBox.vue?vue&type=template&id=5326cffa&scoped=true"
import script from "./CartBox.vue?vue&type=script&lang=js"
export * from "./CartBox.vue?vue&type=script&lang=js"
import style0 from "./CartBox.vue?vue&type=style&index=0&id=5326cffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326cffa",
  null
  
)

export default component.exports